import { createContext, useContext, type ReactNode } from "react";

/** Words the component library says itself. The app passes translated strings (Paraglide) through the provider,
 *  so packages/ui never hard-codes a language. English defaults keep tests and lab pages readable. */
export type UIStrings = {
  clear: string;
  close: string;
  more: string;
  loading: string;
  dismiss: string;
  undo: string;
  retry: string;
  expand: string;
  collapse: string;
  selectAll: string;
  clearSelection: string;
  selected: (n: number) => string;
  addTo: (name: string) => string;
  logged: string;
  overdue: string;
  scrollLeft: string;
  scrollRight: string;
  openPanel: string;
  previewing: (who: string) => string;
  exitPreview: string;
  noResults: string;
};

export const defaultStrings: UIStrings = {
  clear: "Clear",
  close: "Close",
  more: "More",
  loading: "Loading",
  dismiss: "Dismiss",
  undo: "Undo",
  retry: "Try again",
  expand: "Expand",
  collapse: "Collapse",
  selectAll: "Select all",
  clearSelection: "Clear selection",
  selected: (n) => `${n} selected`,
  addTo: (name) => `Add to ${name.toLocaleLowerCase()}`,
  logged: "logged",
  overdue: "overdue",
  scrollLeft: "Scroll left",
  scrollRight: "Scroll right",
  openPanel: "Open",
  previewing: (who) => `Previewing as ${who}`,
  exitPreview: "Exit preview",
  noResults: "No results",
};

const Ctx = createContext<UIStrings>(defaultStrings);
export function UIStringsProvider({ value, children }: { value: Partial<UIStrings>; children: ReactNode }) {
  return <Ctx.Provider value={{ ...defaultStrings, ...value }}>{children}</Ctx.Provider>;
}
export const useStrings = () => useContext(Ctx);
